import React, { useEffect, useState } from 'react';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import ErrorMessage from './components/ErrorMessage';
import { TeamLifecycleEvent } from '../../models/TeamLifecycleEvent';
import { performLifecycleTransition } from '../../api/TeamApi';
import HttpError from '../../common/ExtendedError';
import DeepLinkError from '../../common/DeepLinkError';

const PersonalizationStartDeepLinkPage: React.FC = () => {
  const lifecycleEvent = { command: 'teamStartPersonalization' } as TeamLifecycleEvent;
  const [error, setError] = useState<Error | undefined>(undefined);

  if (error && error instanceof HttpError) {
    switch (error.response.status) {
      case 404:
        throw new DeepLinkError('No team present');
      case 409:
        throw new DeepLinkError('Personalization can not be performed, there are no active team members or personalization is already done');
      default:
        throw error;
    }
  }

  useEffect(() => {
    performLifecyclePersonalizationStart();
  }, []);

  const performLifecyclePersonalizationStart = async () => {
    try {
      const lifecycleSnapshot = await performLifecycleTransition(lifecycleEvent);

      const transition = lifecycleSnapshot.possibleTransitions.find((element) => !!element['teamStartPersonalization']);
      const maybeRedirectToUrl = transition?.teamStartPersonalization?.precondition?.redirectTo;
      maybeRedirectToUrl && window.location.assign(maybeRedirectToUrl as string);
    } catch (e) {
      setError(e);
    }
  };

  return (
    <PageWrapper title='Hauptkontoänderung-Erfolgreich'>
      <div className='margin-vertical-xl align-center'>{error && <ErrorMessage />}</div>
    </PageWrapper>
  );
};
export default PersonalizationStartDeepLinkPage;
